import moment from 'moment';

/**
 * Retorna as informações padronizadas de status de um processo seletivo ou vaga no Portal do Candidato.
 * 
 * Regras:
 * 1. Encerrado:
 *    - Se subscriber_end_date já passou (end.isBefore(now))
 *    - Ou se o status do processo for 'inscricao_encerrada' ou etapas posteriores de processo
 * 2. Em breve:
 *    - Se subscriber_initial_date for no futuro (initial.isAfter(now))
 *    - Ou se não houver subscriber_initial_date e o status cadastrado for 'em_breve'
 * 3. Aberto:
 *    - Se a data inicial já passou (initial.isSameOrBefore(now)) e a data final ainda não expirou
 *    - Ou se o status for de inscrição e não estiver expirado
 */
export const getPspStatusInfo = (item) => {
    if (!item) {
        return {
            type: 'closed',
            label: '✕ Encerrado',
            tableLabel: 'Encerrada',
            badgeClass: 'psp-status-badge--closed',
            textClass: 'psp-job-status--closed',
            bannerClass: 'psp-card-banner--gray',
            footerText: 'Inscrições encerradas',
            isOpen: false,
            isUpcoming: false,
            isClosed: true,
            isUpcomingBox: false
        };
    }

    const now = moment();
    const rawStatus = item.status || item.selection_process_status || '';
    const initial = item.subscriber_initial_date ? moment(item.subscriber_initial_date) : null;
    const end = item.subscriber_end_date ? moment(item.subscriber_end_date) : null;

    // Etapas em que a fase de inscrições públicas já foi encerrada
    const closedStatuses = [
        'inscricao_encerrada',
        'provas',
        'analise_resultados',
        'documentos',
        'resultado_parcial',
        'resultado_final'
    ];

    // 1. Encerrado
    if ((end && end.isBefore(now)) || closedStatuses.includes(rawStatus)) {
        return {
            type: 'closed',
            label: '✕ Encerrado',
            tableLabel: 'Encerrada',
            badgeClass: 'psp-status-badge--closed',
            textClass: 'psp-job-status--closed',
            bannerClass: 'psp-card-banner--gray',
            footerText: end ? `Inscrições encerradas em ${end.format('DD/MM/YYYY')}` : 'Inscrições encerradas',
            isOpen: false,
            isUpcoming: false,
            isClosed: true,
            isUpcomingBox: false
        };
    }

    // 2. Em Breve
    // Se a data de abertura for futura OU (se não houver data definida e o status for 'em_breve')
    if ((initial && initial.isAfter(now)) || (!initial && rawStatus === 'em_breve')) {
        return {
            type: 'upcoming',
            label: '⏳ Em Breve',
            tableLabel: 'Em breve',
            badgeClass: 'psp-status-badge--upcoming',
            textClass: 'psp-job-status--upcoming',
            bannerClass: 'psp-card-banner--amber',
            footerText: initial ? `Inscrições abrem em ${initial.format('DD/MM/YYYY')}` : 'Inscrições em breve',
            isOpen: false,
            isUpcoming: true,
            isClosed: false,
            isUpcomingBox: true
        };
    }

    // 3. Aberto
    // Se a data inicial já passou e a data final ainda não expirou
    const idSeed = String(item.id || item.selection_process_id || '0');
    const bannerColor = idSeed.charCodeAt(0) % 2 === 0 ? 'psp-card-banner--blue' : 'psp-card-banner--green';

    return {
        type: 'open',
        label: '● Inscrições Abertas',
        tableLabel: 'Inscrições abertas',
        badgeClass: 'psp-status-badge--open',
        textClass: 'psp-job-status--open',
        bannerClass: bannerColor,
        footerText: end ? `Encerra em ${end.format('DD/MM/YYYY')}` : 'Inscrições abertas',
        isOpen: true,
        isUpcoming: false,
        isClosed: false,
        isUpcomingBox: false
    };
};
